export default [
	{
		id: 1,
		useInEbiz: true,
		originalText: 'Minimális kockázat',
		displayTexts: {
			hu: 'Minimális kockázati besorolás',
			en: 'TODO English text'
		}
	},
	{
		id: 2,
		useInEbiz: true,
		originalText: ' Átlag alatti kockázat',
		displayTexts: {
			hu: 'Átlag alatti kockázati besorolás',
			en: 'TODO English text'
		}
	},
	{
		id: 3,
		useInEbiz: true,
		originalText: 'Átlagot meghaladó kockázat',
		displayTexts: {
			hu: 'Átlagot meghaladó kockázati besorolás',
			en: 'TODO English text'
		}
	},
	{
		id: 4,
		useInEbiz: true,
		originalText: 'Kiemelten magas kockázat',
		displayTexts: {
			hu: 'Kiemelten magas kockázati besorolás',
			en: 'TODO English text'
		}
	}
];
